import { render, staticRenderFns } from "./SelectGameResult.vue?vue&type=template&id=46b745cc&scoped=true&"
import script from "./SelectGameResult.vue?vue&type=script&lang=js&"
export * from "./SelectGameResult.vue?vue&type=script&lang=js&"
import style0 from "./SelectGameResult.vue?vue&type=style&index=0&id=46b745cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b745cc",
  null
  
)

export default component.exports